import React, { useState, useContext } from 'react'
import { useTranslation } from 'react-i18next';
import noVisitada from "../icons/noVisitada.svg"
import { withRouter } from "../providers/withRouter";
import Swal from 'sweetalert2';
import { Tooltip } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material';
import { UsuarioContext } from "../providers/userContext";
import { formatoFechas, formatoFechasEs } from '../functions/funciones';
import { noRealizadaKae } from '../services/instalacion.service';
import { toast } from "react-toastify";
import { FaEye } from "react-icons/fa";
const theme = createTheme();
const MAX_COMENTARIO = 200;



const NoVisitadoKAE = ({ instalacion }) => {
  const { t } = useTranslation('common');
  const user = useContext(UsuarioContext)
  const [noRealizado, setNoRealizado] = useState(!!instalacion.unRealized);
  const [ObsTexto, setObsTexto] = useState(instalacion.unRealizedObservations || '');
  const [CommTexto, setCommTexto] = useState(instalacion.unRealizedComments || '');
  const [fecha, setFecha] = useState(instalacion.unRealizedDate ? formatoFechasEs(instalacion.unRealizedDate) : '');

  const puedeMarcar = user.rol === 'TECH' || user.rol === 'TECH_COOR';

  const guardar = async (datos, mensaje) => {
    const toastInfo = toast.info(t('documents.savingData'), { autoClose: false });
    // noRealizadaKae no lanza: devuelve la respuesta o el error
    const res = await noRealizadaKae(instalacion.id, datos);
    if (res?.status === 200 || res?.status === 201) {
      toast.update(toastInfo, { render: mensaje, type: toast.TYPE.SUCCESS, autoClose: true });
      setNoRealizado(!!datos.unRealized);
      setObsTexto(datos.unRealizedObservations || '');
      setCommTexto(datos.unRealizedComments || '');
      setFecha(datos.unRealizedDate ? formatoFechasEs(datos.unRealizedDate) : '');
    } else {
      toast.update(toastInfo, { render: t('messages.error'), type: toast.TYPE.ERROR, autoClose: true });
    }
  };

  const abrir = async () => {
    const result = await Swal.fire({
      title: t('visits.noVisitReason'),
      html: `<select id="motivoTexto" style="width: 373px; height: auto; font-size:14px; padding:10px; border: 1px solid #d9d9d9; border-radius: .1875em; box-shadow: inset 0 1px 1px rgba(0, 0, 0, .06), 0 0 0 3px rgba(0, 0, 0, 0);" className="swal2-input" >
                <option>${t('visits.kaeOnlyPresidentAttends')}</option>
                <option>${t('visits.kaeAlreadySignaled')}</option>
                <option>${t('visits.kaeUnderConstruction')}</option>
                <option>${t('visits.kaeNoAnswerWillReturn')}</option>
                <option>${t('visits.kaeGarageKeyMissing')}</option>
              </select>
              <textarea id="motivoComentario" placeholder="${t('visits.specifyReason')}" style="width: 373px; height: 150px; font-size:13px; padding:10px;" class="swal2-textarea"></textarea>
              <div id="charCounter" style="width: 373px; text-align: right; font-size: 12px; color: #888; margin-top: -8px;">0 / ${MAX_COMENTARIO}</div>`,
      confirmButtonText: t('actions.save'),
      confirmButtonColor: '#05811b',
      showCancelButton: true,
      cancelButtonText: t('actions.cancel'),
      cancelButtonColor: '#d33',
      showDenyButton: noRealizado,
      denyButtonText: t('visits.removeNoVisitReason'),
      denyButtonColor: `#33383b`,
      focusConfirm: false,
      didOpen: () => {
        const select = Swal.getPopup().querySelector('#motivoTexto');
        const textarea = Swal.getPopup().querySelector('#motivoComentario');
        const counter = Swal.getPopup().querySelector('#charCounter');
        const confirmBtn = Swal.getConfirmButton();

        const updateCounter = () => {
          const len = textarea.value.length;
          const excedido = len > MAX_COMENTARIO;
          counter.textContent = `${len} / ${MAX_COMENTARIO}`;
          counter.style.color = excedido ? '#d33' : len >= MAX_COMENTARIO * 0.85 ? '#e67e22' : '#888';
          textarea.style.color = excedido ? '#d33' : '#000000';
          confirmBtn.disabled = excedido;
          confirmBtn.style.opacity = excedido ? '0.5' : '1';
          confirmBtn.style.cursor = excedido ? 'not-allowed' : 'pointer';
        };

        if (select && ObsTexto) {
          select.value = ObsTexto.trim();
        }
        textarea.value = CommTexto;
        updateCounter();
        textarea.addEventListener('input', updateCounter);
      },
      preConfirm: () => {
        const texto = Swal.getPopup().querySelector('#motivoTexto').value
        const comentario = Swal.getPopup().querySelector('#motivoComentario').value
        if (!texto) {
          Swal.showValidationMessage(t('visits.insertText'))
          return false;
        }
        if (comentario.length > MAX_COMENTARIO) {
          Swal.showValidationMessage(`El comentario supera los ${MAX_COMENTARIO} caracteres (${comentario.length - MAX_COMENTARIO} de más)`);
          return false;
        }
        return { texto, comentario }
      }
    });

    if (result.isConfirmed) {
      await guardar({
        unRealized: true,
        unRealizedDate: formatoFechas(new Date()),
        unRealizedObservations: result.value.texto,
        unRealizedComments: result.value.comentario || null
      }, t('visits.dataSavedSuccess'));
    } else if (result.isDenied) {
      await guardar({
        unRealized: false,
        unRealizedDate: null,
        unRealizedObservations: null,
        unRealizedComments: null
      }, t('visits.updatingChanges'));
    }
  };

  if (instalacion.realizada) return null;

  return (
    <>
      {puedeMarcar && !noRealizado && (
        <button type="button" className='btn' onClick={abrir}>
          <FaEye />
        </button>
      )}
      {noRealizado && (
        <button type="button" style={{ padding: 0 }} className='btn' onClick={puedeMarcar ? abrir : undefined}>
          <ThemeProvider theme={theme}>
            <Tooltip title={
              <>
                <div>{fecha} - {ObsTexto}</div>
                {CommTexto && (
                  <div style={{ whiteSpace: 'pre-line' }}>{t('form.comments')}: {CommTexto}</div>
                )}
              </>
            }>
              <img src={noVisitada} alt="No visitado" className="tableIcon" />
            </Tooltip>
          </ThemeProvider>
        </button>
      )}
    </>
  );
}

export default withRouter(NoVisitadoKAE);
